export default __webpack_public_path__ + "static/media/DDU_Degree.96eb7e98.pdf";